<template>
  <div>
    <div v-if="hasHelp || hasError || maxLength" :class="wrapClass">
      <p v-if="hasHelp" :class="helpClass">{{ help }}</p>
      <p v-else-if="hasError" :class="errorClass">{{ error }}</p>
      <p v-if="maxLength" :class="maxLengthClass">
        {{ inputLength }} / {{ maxLength }}
      </p>
    </div>
    <p v-if="hasHelp && hasError" :class="errorClass">{{ error }}</p>
  </div>
</template>
<script>
export default {
    name: "field-error-help-length",
    props: {
        error: {type: String, default: ''},
        help: {type: String, default: ''},
        inputLength: {type: Number, default: 0},
        maxLength: {type: Number, default: 0},
    },
    computed: {
        errorClass() {
            return "text-xs text-red-600";
        },
        hasError() {
            return !!this.error;
        },
        hasHelp() {
            return !!this.help;
        },
        helpClass() {
            return "text-xs text-gray-500";
        },
        maxLengthClass() {
            return this.inputLength <= this.maxLength ? this.helpClass : this.errorClass;
        },
        wrapClass() {
            if ((this.hasError || this.hasHelp) && this.maxLength) {
                return 'mt-1 flex justify-between';
            }
            if (this.maxLength) {
                return 'mt-1 flex justify-end';
            }
            return 'mt-1 flex justify-start';
        }
    }
}
</script>